/* Indulge Erotica: four-act scroll-controlled film, accessible fallback, user-triggered sound. */
(function(){
  if(window.__indulgeJourney4Loaded)return;
  window.__indulgeJourney4Loaded=true;
  var sessionKey='indulge-journey-exited-this-tab';
  var thresholds=[0,.25,.50,.75];
  function start(root){
    if(root.dataset.indulgeInitialised==='true')return;
    root.dataset.indulgeInitialised='true';
    if(root.dataset.hasMotion!=='true')return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var scenes=Array.prototype.slice.call(root.querySelectorAll('[data-indulge-scene]'));
    var all=Array.prototype.slice.call(root.querySelectorAll('video.indulge-journey__video'));
    var sound=root.querySelector('[data-indulge-sound]');
    var skip=root.querySelector('[data-indulge-skip]');
    var replay=root.querySelector('[data-indulge-replay]');
    var progressBar=root.querySelector('[data-indulge-progress]');
    var video=null,loaded=false,soundMode=false,frame=0,seekAt=0,sceneIndex=-1;
    var lastTime=-1,waiting=false;
    function choose(){
      var phone=window.matchMedia('(max-width: 749px)').matches;
      return (phone&&root.querySelector('.indulge-journey__video--mobile'))||
        root.querySelector('.indulge-journey__video--desktop')||
        root.querySelector('.indulge-journey__video--mobile');
    }
    function setScene(index){
      index=Math.max(0,Math.min(3,index));
      if(sceneIndex===index)return;
      sceneIndex=index;
      scenes.forEach(function(el,i){
        var active=i===index;
        el.classList.toggle('is-current',active);
        el.setAttribute('aria-hidden',active?'false':'true');
        if('inert' in el)el.inert=!active;
      });
    }
    function setSound(next){
      soundMode=next;
      if(video){video.muted=!next;if(!next)video.pause();}
      if(sound){sound.textContent=next?'Mute sound':'Play with sound';sound.setAttribute('aria-pressed',next?'true':'false');}
    }
    function fallback(){
      root.classList.remove('is-video-ready');
      loaded=false;
      setSound(false);
    }
    function currentVideo(){
      var next=choose();
      if(!next||video===next)return;
      if(video){video.pause();video.classList.remove('is-active-video');}
      setSound(false);
      video=next;loaded=false;lastTime=-1;
      root.classList.remove('is-video-ready');
      all.forEach(function(el){el.classList.toggle('is-active-video',el===next);el.muted=true;el.playsInline=true;});
      video.preload='auto';
      video.addEventListener('loadedmetadata',function(){if(video===next){loaded=true;requestTick();}},{once:true});
      video.addEventListener('loadeddata',function(){if(video===next)root.classList.add('is-video-ready');},{once:true});
      video.addEventListener('seeked',function(){if(video===next)root.classList.add('is-video-ready');});
      video.addEventListener('error',function(){if(video===next)fallback();},{once:true});
      video.addEventListener('timeupdate',function(){
        if(!soundMode||video!==next)return;
        var frac=video.duration>0?video.currentTime/video.duration:0;
        updateText(frac);
      });
      video.addEventListener('ended',function(){if(video===next){setSound(false);updateText(1);}});
      if(video.readyState>=1){loaded=true;requestTick();}
      else video.load();
    }
    function updateText(pct){
      pct=Math.max(0,Math.min(1,pct));
      setScene(Math.min(3,Math.floor(pct*4)));
      if(progressBar)progressBar.style.width=(pct*100).toFixed(1)+'%';
    }
    function scrollProgress(){
      var travel=Math.max(root.offsetHeight-window.innerHeight,1);
      return Math.max(0,Math.min(1,-root.getBoundingClientRect().top/travel));
    }
    function tick(){
      frame=0;
      if(root.classList.contains('is-skipped'))return;
      currentVideo();
      if(soundMode)return;
      var pct=scrollProgress();
      updateText(pct);
      if(!video||!loaded||!Number.isFinite(video.duration)||video.duration<=0)return;
      var target=pct*Math.max(.1,video.duration-.05);
      if(Math.abs(video.currentTime-target)<.12)return;
      var now=Date.now();
      if(now-seekAt<65){if(!waiting){waiting=true;setTimeout(function(){waiting=false;requestTick()},70);}return;}
      seekAt=now;
      try{video.currentTime=target;lastTime=target;}catch(e){fallback();}
    }
    function requestTick(){if(!frame)frame=requestAnimationFrame(tick);}
    if(skip)skip.addEventListener('click',function(){
      /* "Skip Journey" exits the cinematic scroll experience, not the hero.
         Reveal the static woman poster and return to the beginning of that hero. */
      var heroTop=Math.max(0,Math.round(root.getBoundingClientRect().top+window.scrollY));
      try{sessionStorage.setItem(sessionKey,'1');}catch(e){}
      setSound(false);
      all.forEach(function(el){el.pause();});
      root.classList.add('is-skipped');
      root.classList.remove('is-video-ready');
      setScene(0);
      window.scrollTo({top:heroTop,behavior:'instant'});
      /* Recheck after the sticky film collapses to avoid scroll anchoring and
         keep the top of the static hero visible on mobile and desktop. */
      requestAnimationFrame(function(){
        if(root.classList.contains('is-skipped')){
          var settledTop=Math.max(0,Math.round(root.getBoundingClientRect().top+window.scrollY));
          window.scrollTo({top:settledTop,behavior:'instant'});
        }
      });
    });
    if(replay)replay.addEventListener('click',function(){
      try{sessionStorage.removeItem(sessionKey);}catch(e){}
      setSound(false);root.classList.remove('is-skipped');
      setScene(0);
      var top=root.getBoundingClientRect().top+window.scrollY;
      window.scrollTo({top:top,behavior:'smooth'});
      requestTick();
    });
    if(sound)sound.addEventListener('click',function(){
      currentVideo();
      if(!video)return;
      if(soundMode){setSound(false);requestTick();return;}
      if(!loaded){video.preload='auto';video.load();}
      video.volume=1;
      if(video.ended){try{video.currentTime=0;}catch(e){}}
      setSound(true);
      var played=video.play();
      if(played&&played.catch)played.catch(function(){setSound(false);requestTick();});
    });
    window.addEventListener('scroll',function(){
      /* Do not mute immediately when someone scrolls after choosing sound.
         Audio plays normally while the hero remains visible. */
      if(soundMode){
        var bounds=root.getBoundingClientRect();
        if(bounds.bottom<=0||bounds.top>=window.innerHeight){
          setSound(false);
        }
      }
      requestTick();
    },{passive:true});
    window.addEventListener('resize',function(){currentVideo();requestTick();},{passive:true});
    try{if(sessionStorage.getItem(sessionKey)==='1'){root.classList.add('is-skipped');}}catch(e){}
    setScene(0);
    if(root.classList.contains('is-skipped'))return;
    currentVideo();requestTick();
  }
  function init(){document.querySelectorAll('[data-indulge-journey]').forEach(start);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();